import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useCurrentStoreRole } from "@/hooks";
import { getItems } from "./config";
import { SidebarGroup } from "./sidebar-group";
import { StyledSidebar } from "./styles";

interface SidebarProps {
	isOpen: boolean;
}

const Sidebar = ({ isOpen }: SidebarProps) => {
	const { t } = useTranslation();
	const role = useCurrentStoreRole();
	const items = useMemo(() => (role ? getItems(t, role) : []), [role, t]);

	return (
		<StyledSidebar $isOpen={isOpen}>
			{items.map((group) =>
				group.disabled ? null : (
					<SidebarGroup key={group.label} group={group} />
				),
			)}
		</StyledSidebar>
	);
};

export default Sidebar;
